export default __webpack_public_path__ + "static/media/free-shipping-mobile.f09332a3.png";